export default "__VITE_ASSET__Drcjmksa__"